import { useLocation, useNavigate } from "react-router";
import { useI18n } from "../i18n/index.js";
import type { WorkspaceSummary } from "../lib/api.js";
import { Avatar, CheckIcon, ChevronUpDownIcon, Menu, PlusIcon } from "../ui/index.js";

/** Workspace switcher as a Base UI Menu: current workspace on the trigger, siblings + "new" in the popup. */
export function WorkspaceSwitcher({ workspaces, current }: { workspaces: WorkspaceSummary[]; current: WorkspaceSummary }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useI18n();
  return (
    <Menu.Root>
      <Menu.Trigger className="dt-ws-switcher" aria-label={t("workspace.switcherAria", { name: current.name })}>
        <Avatar name={current.name} src={current.logo} />
        <span className="dt-ws-switcher__name">{current.name}</span>
        <ChevronUpDownIcon />
      </Menu.Trigger>
      <Menu.Content align="start" style={{ minWidth: "var(--anchor-width)" }}>
        <Menu.Group>
          <Menu.GroupLabel>{t("workspace.switch")}</Menu.GroupLabel>
          {workspaces.map((w) => (
            <Menu.Item key={w.id} onClick={() => navigate(`/w/${w.slug}`)} icon={<Avatar name={w.name} src={w.logo} size={18} />} trailing={w.id === current.id && <CheckIcon />}>
              {w.name}
            </Menu.Item>
          ))}
        </Menu.Group>
        <Menu.Separator />
        {/* `from` gives the create page a way back; a first workspace reached by redirect has none. */}
        <Menu.Item onClick={() => navigate("/workspaces/new", { state: { from: location.pathname + location.search } })} icon={<PlusIcon />}>
          {t("workspace.new")}
        </Menu.Item>
      </Menu.Content>
    </Menu.Root>
  );
}
